<template>
  <header class="app-header">
    <!-- 좌측 로고 -->
    <div class="header-left">
      <img src="@/assets/qm-replace-logo.png" alt="logo" class="logo" />
    </div>

    <!-- 중앙 대리점 / 발주처 명 -->
    <div class="header-center">
      {{ resolvedCenterName }}
    </div>

    <!-- 우측 사용자 영역 -->
    <div class="header-right">
      <div class="user-info">
        <UserIcon class="icon" />
        <span class="user-name">{{ resolvedUserName }}</span>
      </div>

      <button class="logout-btn" title="로그아웃" @click="onClickLogout">
        로그아웃
      </button>
    </div>
  </header>
</template>

<script>
import UserIcon from '@/components/icons/UserIcon.vue'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'HeaderBarComponent',

  components: {
    UserIcon,
  },

  props: {
    account: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    authStore() {
      return useAuthStore()
    },

    resolvedCenterName() {
      return this.account?.name || ''
    },

    resolvedUserName() {
      return this.authStore.user?.username || this.account?.id || ''
    }
  },

  methods: {
    onClickLogout() {
      const ok = window.confirm('로그아웃 하시겠습니까?')
      if (!ok) return

      this.authStore.logout()
      this.$router.replace('/login') // .push -> .replace 로 변경. 뒤로가기에서 다시 들어가는 것 방지.
    }
  }
}
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 75px;
  padding: 0 20px;

  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-border);
  border-top: 3px solid var(--color-primary);

  box-sizing: border-box;
}

/* 좌측 */
.header-left {
  display: flex;
  align-items: center;
}

.logo {
  height: 56px;
}

/* 중앙 */
.header-center {
  flex: 1;
  text-align: center;

  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text-main);
}

/* 우측 */
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 6px;

  padding: 6px 10px;
  border-radius: 6px;

  font-size: 0.875rem;
  color: var(--color-text-main);
}

.user-name {
  font-weight: 500;
}

.logout-btn {
  min-width: 88px;
  height: 38px;
  padding: 0 14px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #ffffff;
  border: 1px solid #d7dde5;
  border-radius: 10px;

  font-size: 13px;
  font-weight: 700;
  color: #475569;

  cursor: pointer;

  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    transform 0.12s ease,
    box-shadow 0.18s ease;
}

.logout-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;

  transform: translateY(-2px);

  box-shadow:
    0 8px 18px rgba(15, 23, 42, 0.08);
}

.logout-btn:active {
  transform: translateY(0);
}

.icon {
  width: 18px;
  height: 18px;
  color: var(--color-text-main);
}
</style>